import { DjangoTimeStamped, TimeStamped } from './../django';
import { applyTimezone, parseDate } from './../helpers/date';
import { DjangoUser, parseUser, User } from './../user';

export class PixKey implements TimeStamped {
    id: string;
    key?: string;
    type?: string;
    user?: User;
    // DJANGO TIMESTAMPED
    created: Date;
    modified: Date;

constructor(data: string | PixKey | DjangoPixKey = {}) {
    if (typeof data === 'string') {
      bindConstructorDataToInstance(this, { id: data });
    } else {
      bindConstructorDataToInstance(this, data);
    }
  }
}

function bindConstructorDataToInstance(instance: PixKey, data: PixKey | DjangoPixKey){
    const jsData = bindDjangoPropsToJs(data);
    instance.id = jsData.id;
    instance.key = jsData.key;
    instance.type = jsData.type;
    instance.user = parseUser(jsData.user);
    instance.created = applyTimezone(parseDate(jsData.created), 0);
    instance.modified = applyTimezone(parseDate(jsData.modified), 0)
}

export interface DjangoPixKey extends DjangoTimeStamped {
    id?: string;
    key?: string;
    type?: string;
    user?: string | DjangoUser;
    // DJANGO TIMESTAMPED
    created?: string;
    modified?: string;
}

function bindDjangoPropsToJs(data: PixKey | DjangoPixKey) {
    const djangoData = data as DjangoPixKey;
    const jsData = data as PixKey;
    return {
      ...data,
      id: djangoData.id || jsData.id,
      key: djangoData.key || jsData.key,
      type: djangoData.type || jsData.type,
      created: djangoData.created || jsData.created,
      modified: djangoData.modified || jsData.modified
    };
}

export function parsePixKey(data?: string | PixKey | DjangoPixKey) {
  if(data) {
    return new PixKey(data);
  } else {
    return undefined;
  }
}
